export default __webpack_public_path__ + "static/media/KVþÖ¢Þ¢ª´╝ìÕëì15Õ║ª-06.2ef8218a.jpg";